export default class TextImageColumns {
	constructor() {
		const imageInColumn: NodeListOf<HTMLElement> = document.querySelectorAll('.wp-block-image');

		imageInColumn.forEach((image: HTMLElement) => {
			if (image.parentElement?.classList.contains('wp-block-column')) {
				image.parentElement.classList.add('wp-block-column--has-image');
			}
		});
	}
}
